import { _fetch as fetchSecure } from '@hobs/utils/fetch';

import {
  FORSUBMIT,
  GET,
  CREATE,
  UPDATE,
  DELETE,
  CLEAR
} from '@hobs/constants/units';

export function getUnitsForSubmit() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('parties/units/forSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FORSUBMIT.REQUEST };
  }
  function success(response) {
    return { type: FORSUBMIT.SUCCESS, response };
  }
  function failure(error) {
    return { type: FORSUBMIT.FAILURE, error };
  }
}

export function createUnit(unit) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('parties/current/units', { body: unit, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success() {
    return { type: CREATE.SUCCESS };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function getUnit(unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`parties/current/units/${unitId}`)
      .then(response => {
        if (response.payload) {
          dispatch(success(response.payload));
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function updateUnit(unit) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('parties/current/units', { body: unit, method: 'PUT' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: UPDATE.REQUEST };
  }
  function success(response) {
    return { type: UPDATE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function deleteUnit(unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`parties/current/units/${unitId}`, { method: 'DELETE' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: DELETE.REQUEST };
  }
  function success() {
    return { type: DELETE.SUCCESS };
  }
  function failure(error) {
    return { type: DELETE.FAILURE, error };
  }
}

export function clearUnit() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}
